export default __webpack_public_path__ + "static/media/avatar.7df31d25.png";